module.exports = __webpack_public_path__ + "img/eva-er-ikke-laengere-1.6b7a9370.png";